import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BannerService {
    public readonly showGeneralBanner = new BehaviorSubject<boolean>(false);
    setGeneralBannerVisibility(show: boolean): void {
        this.showGeneralBanner.next(show);
    }
}
